import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=b64b8708&scoped=true&"
import script from "./blacklist.vue?vue&type=script&lang=ts&"
export * from "./blacklist.vue?vue&type=script&lang=ts&"
import style0 from "./blacklist.vue?vue&type=style&index=0&id=b64b8708&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64b8708",
  null
  
)

export default component.exports